export class ReturnStatus {

    public description: string;
    public status: boolean;
    public returnObject: any;

}

